import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthInterceptor } from "../../services/AuthInterceptor.Service";
import Spinnerr from "../Commaon/Spinner";
import Toaster from "../Commaon/Toaster";

const ViewTestModel = () => {
  const { testId } = useParams();
  const navigate = useNavigate();

  const [test, setTest] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState(null);

  useEffect(() => {
    if (!testId) return;

    const fetchTest = async () => {
      try {
        setLoading(true);

        const response = await AuthInterceptor(`/admin/test/${testId}`, {
          method: "GET",
        });

        const data = response.data;

        if (data?.s === 200 && data?.r) {
          setTest(data.r);
        } else {
          throw new Error(data?.m || "Failed to load test");
        }
      } catch (error) {
        setSnack({
          notification: {
            message: error.message || "Error loading test",
            type: "error",
          },
        });
      } finally {
        setLoading(false);
      }
    };

    fetchTest();
  }, [testId]);

  if (loading) return <Spinnerr show={true} />;

  return (
    <>
      {snack && (
        <Toaster
          notification={snack.notification}
          onClose={() => setSnack(null)}
        />
      )}

      <div className="card shadow-sm border-0 rounded-3 p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">View Test</h3>

          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => navigate(-1)}
            >
              ← Back
            </button>

            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => navigate(`/tests/edit/${testId}`)}
            >
              Edit
            </button>
          </div>
        </div>

        {test && (
          <div className="row g-4">
            {/* BASIC INFO */}
            <div className="col-md-6">
              <div className="border rounded p-3 h-100">
                <h6 className="text-muted mb-3">Basic Information</h6>

                <p><strong>Title:</strong> {test.title || "-"}</p>
                <p><strong>Age Limit:</strong> {test.ageLimit || "-"}</p>
                <p><strong>Recommended Gender:</strong> {test.recommendedGender || "All"}</p>
                <p><strong>Fasting Required:</strong> {test.fasting ?? "-"}</p>
                <p><strong>Sample Type:</strong> {test.sampleType || "-"}</p>
              </div>
            </div>

            {/* PRICING */}
            <div className="col-md-6">
              <div className="border rounded p-3 h-100">
                <h6 className="text-muted mb-3">Pricing</h6>

                <p><strong>MRP:</strong> ₹{test.originalPrice || "-"}</p>
                <p><strong>Discounted Price:</strong> ₹{test.discountedPrice || "-"}</p>
                <p><strong>Discount Percent:</strong> {test.discountPercent || 0}%</p>
                <p><strong>GST Slab:</strong> GST {test.gstSlab ?? test.gst ?? 0}%</p>
              </div>
            </div>

            {/* DESCRIPTION */}
            <div className="col-12">
              <div className="border rounded p-3">
                <h6 className="text-muted mb-2">Description</h6>
                <p className="mb-0">{test.description || "-"}</p>
              </div>
            </div>

            {/* PARAMETERS */}
            <div className="col-12">
              <div className="border rounded p-3">
                <h6 className="text-muted mb-2">Parameters</h6>

                {test.parameters?.length ? (
                  <ul className="mb-0">
                    {test.parameters.map((p, i) => (
                      <li key={i}>{p.name}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="mb-0">-</p>
                )}
              </div>
            </div>

            {/* REPORT & CRITERIA */}
            <div className="col-md-6">
              <div className="border rounded p-3 h-100">
                <h6 className="text-muted mb-2">Report</h6>
                <p className="mb-0">{test.report || "-"}</p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded p-3 h-100">
                <h6 className="text-muted mb-2">Note</h6>
                <p className="mb-0">{test.testCriteria || "-"}</p>
              </div>
            </div>

            {/* INSTRUCTIONS */}
            <div className="col-12">
              <div className="border rounded p-3">
                <h6 className="text-muted mb-2">Test Instructions</h6>
                <p className="mb-0">{test.testInstruction || "-"}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewTestModel;
